import { Helmet } from "react-helmet-async";
import { siteSeo } from "../content/seo";

const PageMeta = ({ meta, jsonLd }) => {
  const canonicalUrl = `${siteSeo.siteUrl}${meta.path}`;
  const ogImage = `${siteSeo.siteUrl}${meta.ogImage || siteSeo.defaultOgImage}`;
  const ogImageAlt = meta.ogImageAlt || siteSeo.ogImageAlt;
  const schemas = jsonLd
    ? Array.isArray(jsonLd)
      ? jsonLd
      : [jsonLd]
    : [];

  return (
    <Helmet>
      <html lang="en-GB" />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      {meta.robots ? <meta name="robots" content={meta.robots} /> : null}
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteSeo.siteName} />
      <meta property="og:locale" content={siteSeo.locale} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={ogImageAlt} />
      <meta property="og:image:width" content={String(siteSeo.ogImageWidth)} />
      <meta property="og:image:height" content={String(siteSeo.ogImageHeight)} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={siteSeo.twitterHandle} />
      <meta name="twitter:creator" content={siteSeo.twitterHandle} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:image:alt" content={ogImageAlt} />

      {schemas.map((schema, index) => (
        <script
          key={`${schema["@type"]}-${index}`}
          type="application/ld+json"
        >
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default PageMeta;
